import React from 'react'
import { Container } from 'src/components/common/Container'
import { ReactHookForm } from 'src/components/common/ReactHookForm'
import styled, { css } from 'styled-components'
import { Noto_body1_b16 } from 'src/styles/fonts/NotoSansKrFonts'
import { Typography } from 'src/components/common/Typography'
import { layoutMaxSize, mediaMaxWidth } from 'src/styles/mixin'
import Button, { ButtonOption3 } from 'src/components/common/Button'
import useLoginDetector from 'src/hooks/useLoginDetector.hook'
import { SmallDivider } from 'src/components/common/Divider'
import { SelfRegCouponCreatePageProps } from 'src/pages/SelfRegCouponPage/SelfRegCouponCreatePage/index'
import SelfRegCommonFormItems from 'src/pages/SelfRegCouponPage/_components/SelfRegCommonFormItems'
import SelfRegCreateController from 'src/pages/SelfRegCouponPage/SelfRegCouponCreatePage/_components/SelfRegCreateController'
import { useFormContext } from 'react-hook-form'
import { SelfRegisterCouponFormItemsType } from 'src/types/react-hook-form'

const SelfRegCouponCreatePageView = (props: SelfRegCouponCreatePageProps) => {
  const { selfRegCouponCreateHandler } = props
  const { handleSubmit, formState } = useFormContext<SelfRegisterCouponFormItemsType>()
  const { isValid } = formState
  const { isLogin } = useLoginDetector()
  return (
    <React.Fragment>
      <S.SelfRegContainer $option="flex_column_space_between">
        <ReactHookForm style={S.SelfRegFormWrap}>
          <SelfRegCreateController {...props} />
          <Container $option="flex_column" $row_gap="20px" $style={S.SelfRegTextInputWrap}>
            <Typography $fontStyle={Noto_body1_b16}>쿠폰 정보를 입력해주세요.</Typography>
            <SelfRegCommonFormItems {...props} />
          </Container>
        </ReactHookForm>
        <SmallDivider />
        <S.SelfRegFormBottomContents>
          <Button
            option={ButtonOption3('active')}
            disabled={!isLogin || !isValid}
            onClickFn={handleSubmit(selfRegCouponCreateHandler)}
          >
            쿠폰등록
          </Button>
        </S.SelfRegFormBottomContents>
      </S.SelfRegContainer>
    </React.Fragment>
  )
}
export default SelfRegCouponCreatePageView

const S = {
  SelfRegContainer: styled(Container)`
    padding-bottom: 68px;
    flex: 1;
  `,
  SelfRegFormWrap: css`
    display: flex;
    flex-direction: column;
  `,
  SelfRegTextInputWrap: css`
    width: calc(100% - 80px);
    ${mediaMaxWidth('499')} {
      width: calc(100% - 40px);
    }
    margin: 30px auto 0 auto;
    padding-bottom: 50px;
  `,
  SelfRegFormBottomContents: styled(Container)`
    z-index: 2;
    ${layoutMaxSize};
    padding: 10px;
    position: fixed;
    bottom: 0;
  `,
}
